import React, { useEffect, useState } from 'react';
import styles from './TagSelectionModel.module.css';
import close from '../../../../../assets/Close.svg';
import { useSelector } from 'react-redux';

const TagSelectionModel = ({
  channelNames,
  setIsTagGroupsModel,
  setSelectedChannels,
  selectedChannels,
  setSelectedGroups,
  selectedGroups,
  arrangeData,
  hisData,
  allChannels,
  comparisonHisData,
  arrangeComparisonData,
}) => {
  const tagGroupsArr = useSelector((state) => state.tagGroup.tagGroupsArr);
  // const tagGroupsArr = [];
  // const historyData = useState((state) => state.projectData.historyData);
  const historyData = [];

  // State to track "Select All" checkboxes
  const [selectAllTags, setSelectAllTags] = useState(false);
  const [selectAllGroups, setSelectAllGroups] = useState(false);

  useEffect(() => {
    setSelectedGroups([]);
    setSelectedChannels([]);
  }, []);

  // Update selectAllTags based on selectedChannels
  useEffect(() => {
    if (channelNames.length > 0) {
      setSelectAllTags(selectedChannels.length === allChannels.length);
    }
  }, [selectedChannels, channelNames]);

  // Update selectAllGroups based on selectedGroups
  useEffect(() => {
    if (tagGroupsArr.length > 0) {
      setSelectAllGroups(selectedGroups.length === tagGroupsArr.length);
    }
  }, [selectedGroups, tagGroupsArr]);

  // Handle selecting/deselecting individual tags
  const handleTagsChange = (tag) => {
    setSelectedChannels((prevSelectedChannels) => {
      if (prevSelectedChannels.includes(tag)) {
        return prevSelectedChannels.filter((item) => item !== tag);
      } else {
        return [...prevSelectedChannels, tag];
      }
    });
  };

  // Handle selecting/deselecting individual groups
  const handleGroupsChange = (group) => {
    setSelectedGroups((prevSelectedGroups) => {
      if (prevSelectedGroups.includes(group)) {
        return prevSelectedGroups.filter((item) => item !== group);
      } else {
        return [...prevSelectedGroups, group];
      }
    });
  };

  // Handle "Select All" for tags
  const handleSelectAllTags = () => {
    if (selectAllTags) {
      setSelectedChannels([]); // Deselect all tags
    } else {
      setSelectedChannels(allChannels); // Select all tags
    }
  };

  // Handle "Select All" for groups
  const handleSelectAllGroups = () => {
    if (selectAllGroups) {
      setSelectedGroups([]); // Deselect all groups
    } else {
      setSelectedGroups(tagGroupsArr.map((group) => group.groupName)); // Select all groups
    }
  };

  const handleSave = () => {
    if (hisData?.length > 0) {
      arrangeData(hisData);
    }
    if (
      comparisonHisData?.currentRange?.data?.length > 0 &&
      comparisonHisData?.previousRange?.data?.length > 0
    ) {
      arrangeComparisonData(comparisonHisData);
    }

    setIsTagGroupsModel(false);
  };

  return (
    <div className={styles.model}>
      <div className={styles.container}>
        {/* Header */}
        <button
          onClick={() => setIsTagGroupsModel(false)}
          className={styles.closeBtn}
        >
          <img src={close} alt="close" />
        </button>

        {/* Scrollable Content */}
        <div className={styles.content}>
          <div className={styles.mainWrapper}>
            {/* Tags */}
            <div className={styles.wrapper}>
              <label className={styles.title}>Tags</label>

              {allChannels?.length > 0 ? (
                <>
                  <div className={styles.channel}>
                    <input
                      type="checkbox"
                      checked={selectAllTags}
                      onChange={handleSelectAllTags}
                    />
                    <label className={styles.channelLabel}>Select All</label>
                  </div>

                  {allChannels.map((channel, i) => (
                    <div className={styles.channel} key={i}>
                      <input
                        type="checkbox"
                        checked={selectedChannels.includes(channel)}
                        onChange={() => handleTagsChange(channel)}
                      />
                      <label className={styles.channelLabel}>{channel}</label>
                    </div>
                  ))}
                </>
              ) : (
                <p>Tags being loaded...</p>
              )}
            </div>

            {/* Groups */}
            <div className={styles.wrapper}>
              <label className={styles.title}>Groups</label>

              {tagGroupsArr?.length > 0 ? (
                <>
                  <div className={styles.channel}>
                    <input
                      type="checkbox"
                      checked={selectAllGroups}
                      onChange={handleSelectAllGroups}
                    />
                    <label className={styles.channelLabel}>Select All</label>
                  </div>

                  {tagGroupsArr.map((group, i) => (
                    <div className={styles.channel} key={i}>
                      <input
                        type="checkbox"
                        checked={selectedGroups.includes(group.groupName)}
                        onChange={() => handleGroupsChange(group.groupName)}
                      />
                      <label className={styles.channelLabel}>
                        {group.groupName}
                      </label>
                    </div>
                  ))}
                </>
              ) : (
                <p>No Groups Available</p>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className={styles.btnWrapper}>
          <button className={styles.saveBtn} onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default TagSelectionModel;